import React from "react";
import { CgToolbox } from "react-icons/cg";
import { FaUserGraduate } from "react-icons/fa";
import { GiAtom } from "react-icons/gi";
import bgimg from "../../assets/img/rnd-bg.jpg";
import PageHeader from "../PageHeader/PageHeader";
import Testimonial from "../Testimonial/Testimonial";
import RnDAbout from "./RnDAbout";
import RnDCommunity from "./RnDCommunity";
import RnDOffers from "./RnDOffers";
import classes from "./RndD.module.css";
import RndDHexaCard from "./RndDHexaCard";
import { NavLink } from "react-router-dom";

const RndD = () => {
  return (
    <>
      {/* SEO Friendly Hero */}
      <PageHeader
        heading="Driving Innovation Through Research & Development"
        bgimg={bgimg}
      />

      <main className={classes.content} role="main">
        {/* About */}
        <section className={classes.about}>
          <h1>Bringing Academics & Industry Together</h1>
          <RnDAbout />
        </section>

        {/* Core Pillars */}
        <section
          className={`${classes.about} ${classes["about-cards"]}`}
          aria-label="R&D Core Pillars"
        >
          <h1>Our Core Pillars of Research & Development</h1>
          <div className={classes.cards}>
            <RndDHexaCard
              heading="Research"
              content="Innovative research powering patents, publications, and breakthrough technologies."
              Icon={GiAtom}
            />
            <RndDHexaCard
              heading="Development"
              content="End-to-end product development—software, hardware, or hybrid systems."
              Icon={CgToolbox}
            />
            <RndDHexaCard
              heading="Education"
              content="Industry-driven training programs preparing youth for tomorrow’s jobs."
              Icon={FaUserGraduate}
            />
          </div>
        </section>

        {/* Mentorship */}
        <section className={`${classes.about} ${classes.aboutbg}`}>
          <h1>Personalized One-on-One Mentorship</h1>
          <p className={classes.subtext}>
            Learn directly from industry experts with tailored guidance for your
            career or project. Our mentorship ensures you gain hands-on,
            practical knowledge that accelerates growth.
          </p>

          <RnDOffers />

          <NavLink
            to="/apply"
            className={classes.ctaBtn}
            aria-label="Apply for mentorship"
          >
            Apply Now
          </NavLink>
        </section>

        {/* Testimonials */}
        <Testimonial />

        {/* Community */}
        <section
          className={`${classes.about} ${classes["community-section"]}`}
          aria-label="R&D Community"
        >
          <h1>Be Part of Our Global R&D Community</h1>
          <p className={classes.subtext}>
            Join a thriving network of innovators, students, and industry
            leaders. Collaborate, learn, and contribute to groundbreaking
            projects that make a real impact.
          </p>

          <RnDCommunity />

          <NavLink
            to="/community"
            className={classes.ctaBtn}
            aria-label="Join community"
          >
            Join Community
          </NavLink>
        </section>

        {/* Metrics */}
        <section className={`${classes.about} ${classes.metrics}`}>
          <h1>Our Impact in Numbers</h1>
          <div className={classes.statsGrid}>
            <div>
              <h2>50+</h2>
              <p>Research Papers Published</p>
            </div>
            <div>
              <h2>200+</h2>
              <p>Students Trained</p>
            </div>
            <div>
              <h2>20+</h2>
              <p>Startups Supported</p>
            </div>
            <div>
              <h2>15+</h2>
              <p>Industry Collaborations</p>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default RndD;
